// extracted by mini-css-extract-plugin
module.exports = {"layout":"layouts__2AQBE","header":"layouts__2qxRX","layoutContent":"layouts__3OyVr","content":"layouts__1O7SW","logo":"layouts__AoI5R"};